<template>
  <div class="container_box">
    <!--功能按钮操作区域-->
    <div class="operation_box" v-if="getPermission('ymsProductSizeTemplate_insert')">
      <!--新增模板-->
      <Button type="primary" @click="addTemplate">{{ $t('key1003293') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        :loading="tableLoading"
        :columns="tableColumns"
        max-height="700"
        :data="tableData">
      </Table>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {handerDataSorting} from "@/utils/common";

export default {
  name: 'sizeTemplateManage',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      tableData: [],
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002628'),
          key: 'name',
          align: 'center',
          width: 450,
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003290'),
          key: 'place',
          align: 'center',
          render(h, params) {
            let arr = [];
            let data = params.row.productSizePartsBos;
            if (data.length > 0) {
              data.map((item) => {
                if (item.cnName) {
                  arr.push(item.cnName);
                }
              });
              if (arr.length > 0) {
                arr = arr.join('、');
              }
            }
            return h('div', arr);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003291'),
          key: 'unit',
          width: 150,
          align: 'center',
          render(h, params) {
            let arr = [];
            let data = params.row.productSizeUnitBos;
            data.map((item) => {
              arr.push(item.name);
            });
            arr = arr.join('、');
            return h('div', arr);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 130,
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsProductSizeTemplate_update'),
                    clickFn: () => {
                      v.$router.push({
                        path: '/updateSizeTemplate',
                        query: {
                          type: 'edit',
                          ymsProductSizeTemplateId: params.row.ymsProductSizeTemplateId
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    color: '#FF0000',
                    show: v.getPermission('ymsProductSizeTemplate_delete'),
                    clickFn: () => {
                      v.deleteTemplate(params.row.ymsProductSizeTemplateId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ]
    };
  },
  created() {
    this.pageParamsStatus = true;
  },
  methods: {
    // 新增模板
    addTemplate() {
      this.$router.push({
        path: '/updateSizeTemplate',
        query: {
          type: 'add'
        }
      });
    },
    // 获取列表的数据
    getList() {
      let v = this;
      if (v.getPermission('ymsProductSizeTemplate_query')) {
        v.tableLoading = true;
        v.axios.get(api.get_ymsProductSizeTemplate_query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data && data.length >0) {
              data.map((item) => {
                item.productSizePartsBos = item.productSizePartsBos.sort(handerDataSorting('sortNo', 'asc'));
              });
            }
            v.tableData = data || [];
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 删除模板
    deleteTemplate(ymsProductSizeTemplateId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003292'),
        onOk: () => {
          v.axios.delete(api.delete_ymsProductSizeTemplate + `${ymsProductSizeTemplateId}`).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  }
};
</script>
